module.exports = __webpack_public_path__ + "img/left-right-pattern-dark.18c6323.svg";